import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { kindFieldOf } from './kindFieldOf';

/**
 * Назва типу запису для шапки, крихт і підказки назви (прототип v4 fSingular): однина типу, а для типу з полем виду (бізнес-аналіз) —
 * підпис виду запису мовою інтерфейсу («Зацікавлена сторона 101»), якщо вид задано (`draft` — значення чернетки мають перевагу); без
 * типу (ще завантажується) — ''.
 */
export function useTypeLabel(rt: IRecordTypeDefinition | undefined, record?: Pick<IRecord, 'values'> | null, draft?: Record<string, unknown>): string {
  const strings = useModuleStrings();
  if (!rt) return '';
  const kind = kindFieldOf(rt);
  const value = kind ? (draft && kind.key in draft ? draft[kind.key] : record?.values[kind.key]) : null;
  if (kind && typeof value === 'string' && value) return strings.option(rt.key, kind.key, value, kind.options?.find((o) => o.value === value)?.label);
  return strings.entity(rt.key, 'singular', rt.singular ?? rt.name);
}
